/*
  Colours on product cards (snippets/product-row-card.liquid): pointing at or focusing a colour shows its photo on the
  card, and leaving the colours puts the card's own photo back. The colours are links, so without this they still
  open the product in that colour. Loaded by the sections that show cards; runs once however often it is included.
*/
if (!window.c4CardSwatches) {
  window.c4CardSwatches = true;
  const image = (node) => node.closest('.row-card')?.querySelector('.row-card-media img');
  const show = (event) => {
    const swatch = event.target.closest?.('[data-card-image]');
    const img = swatch && image(swatch);
    if (!img) return;
    if (!('src' in img.dataset))
      Object.assign(img.dataset, { src: img.getAttribute('src'), srcset: img.srcset });
    img.srcset = '';
    img.src = swatch.dataset.cardImage;
    img.closest('.row-card').dataset.swatched = '';
  };
  const restore = (event) => {
    const list = event.target.closest?.('.card-swatches');
    if (!list || list.contains(event.relatedTarget)) return;
    const img = image(list);
    if (!img || !('src' in img.dataset)) return;
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
    delete img.closest('.row-card').dataset.swatched;
  };
  document.addEventListener('pointerover', show);
  document.addEventListener('focusin', show);
  document.addEventListener('pointerout', restore);
  document.addEventListener('focusout', restore);
}
